import { EmptyCell, type IColumn, Typography } from 'shared/ui'
import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type AuthorizedAppRow } from 'pages/settings/pages/developer/pages/authorizedApps/model/AuthorizedAppRow'

export const authorizedAppsTableColumns: IColumn<AuthorizedAppRow>[] = [
  {
    field: 'name',
    name: 'Name',
    width: '160px',
    maxWidth: '160px',
    paddingHeader: '0 8px 0 12px',
    renderRowCell: (row) => (
      <Typography
        variant='body-md-regular'
        ariaLabel='AuthorizedAppName'
        tag='div'
        ellipsis
        width='100%'
        tooltipProps={{ label: row.name ?? '' }}
      >
        {row.name || <EmptyCell />}
      </Typography>
    ),
  },
  {
    field: 'id',
    name: 'Token identifier',
    width: '380px',
    maxWidth: '380px',
    renderRowCell: (row) => (
      <Typography
        variant='body-md-regular'
        ariaLabel='AuthorizedAppTokenId'
        tag='div'
        ellipsis
        width='100%'
        tooltipProps={{ label: row.id }}
      >
        {row.id || <EmptyCell />}
      </Typography>
    ),
  },
  {
    field: 'created_at',
    name: 'Granted on',
    maxWidth: '150px',
    renderRowCell: (row) => {
      const grantedOn = row.created_at && uiStore.dayjs(row.created_at).format(DayjsFormats.full6)
      if (!grantedOn) return <EmptyCell />
      return (
        <Typography
          variant='body-md-regular'
          ariaLabel='AuthorizedAppGrantedOn'
          tag='div'
          ellipsis
          tooltipProps={{ label: grantedOn }}
        >
          {grantedOn}
        </Typography>
      )
    },
  },
]
